// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const bouffalant: PokeData = {
  "id": 626,
  "name": "bouffalant",
  "height": 16,
  "weight": 946,
  "base_experience": 172,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "swords-dance",
    "horn-attack",
    "fury-attack",
    "tackle",
    "thrash",
    "leer",
    "rage",
    "focus-energy",
    "reversal",
    "scary-face",
    "megahorn",
    "pursuit",
    "revenge",
    "giga-impact",
    "head-charge",
    "throat-chop"
  ],
  "moves": [
    "tackle",
    "leer",
    "scary-face",
    "pursuit",
    "refresh",
    "headbutt",
    "splash",
    "scratch",
    "body-slam",
    "purification",
    "growl",
    "quick-attack",
    "supersonic"
  ],
  "evolution_chain": {
    "id": 318,
    "item": null,
    "species": [
      {
        "name": "bouffalant",
        "order": 627,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 146,
    "speed": 85,
    "ability_power": 169
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
